import { BaseFormState, BaseState, BaseOrderlessState } from './types';

export const BaseFormInitialState: BaseFormState = {
  isLoading: true,
  hasError: false,
  contactOption: { changeContactInfo: 0, preferredContactMethod: '', newContactInfo: '' }
};

export const BaseInitialState: BaseState = {
  ...BaseFormInitialState,
  order: null
};

export const BaseOrderLessInitialState: BaseOrderlessState = {
  ...BaseFormInitialState,
  name: '',
  phone: '',
  email: ''
};
